import * as React from "react";

import "./dragging-rect-mode.scss";

import {cs}          from "@Common/react/chain-services";
import {fragments}   from "@Common/react/fragments";
import {OnUnmounted} from "@Common/react/on-unmounted";
import {scnv}        from "@Common/react/state-change-nested-value";
import {UseState}    from "@Common/react/use-state";
import {Watch}       from "@Common/react/watch";
import {chain}       from "@Common/utils/fs";
import {equalDeep}   from "@Common/utils/objects";

import {applyAspectRatio}     from "../../../common/apply-aspect-ratio";
import {createRectFromCenter} from "../../../common/create-rect-from-center";
import {getContainRatio}      from "../../../common/get-contain-ratio";
import {inSize}               from "../../../common/in-size";
import {multiplySize}         from "../../../common/multiply-size";
import {roundSize}            from "../../../common/round-size";

import {DraggingRect} from "./dragging-rect";

export const DraggingRectMode = ({aspectRatio, next}) => cs(
    ["rectState", (_, next) => UseState({
        // initValue: {rect: {x: 5, y: 2, width: 6, height: 4}},
        next,
    })],

    ({rectState}) => next({
        activate: (rect) => rectState.onChange({rect}),
        ready: rectState.value,
        rect: rectState.value?.rect,
        render: ({frame, getBgColor}) => {
            const size = roundSize(multiplySize(frame.size, 1/frame.ratio));
            return fragments(
                fragments(
                    Watch({
                        value: aspectRatio,
                        compare: equalDeep,
                        onChanged: () => {
                            const rect = (() => {
                                if (!aspectRatio) {
                                    return rectState.value.rect;
                                }

                                return createRectFromCenter(
                                    {x: size.width / 2, y: size.height / 2},
                                    multiplySize(aspectRatio, getContainRatio(size, aspectRatio)),
                                );
                            })();
                            if (!equalDeep(rectState.value.rect, rect)) {
                                rectState.onChange({rect});
                            }
                        },
                    }),
                    OnUnmounted({
                        action: () => rectState.onChange(null),
                    }),
                ),

                rectState.value?.rect && (
                    <div {...{
                        className: "dragging-rect-mode-21o",
                        // style: {
                        //     ...toCssPos(frame.start),
                        //     ...{width: 0, height: 0},
                        // },
                    }}>
                        {DraggingRect({
                            rect: rectState.value.rect,
                            outSize: size,
                            frame,
                            adjPoints: (p1, p2) => chain(
                                inSize(p2, size),
                                (_) => !aspectRatio ? _ : applyAspectRatio({
                                    p2: _,
                                    p1,
                                    aspectRatio,
                                    size,
                                }),
                            ),
                            onChangedRect: (rect) => scnv(rectState, ["rect"], () => rect),
                            getBgColor,
                        })}
                    </div>
                ),

            );
        },
    }),
);
